import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { getClientList } from "../API/getClientData";

const useGetClientList = (searchValue, shouldFetch = true) => {
  const [searchText, setSearchText] = useState("");

  // Debouncing
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(searchValue);
    }, 200);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const query = useQuery({
    queryKey: ["clientList", searchText],
    queryFn: () => getClientList(searchText),
    enabled: !!searchValue && shouldFetch,
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
export default useGetClientList;
